/**
 * 政策业务类型 (后端 sys_biz_type 字典)
 *
 * 用户端 / 律师端共用一份, 后续如需按角色拆分可在调用处覆盖.
 * 默认 'legal', 可通过 .env 中 VITE_POLICY_BIZ_TYPE 覆盖以匹配后端字典实际值.
 */
export const POLICY_BIZ_TYPE =
  (import.meta.env.VITE_POLICY_BIZ_TYPE as string | undefined) ?? 'legal'

/**
 * 路由 path → 后端 sys_policy.type 的映射
 *
 * 路由保持 kebab-case (URL 友好), 后端字典常用下划线.
 * 若后端 type 与默认映射不一致, 修改下表即可, 业务代码无须改动.
 */
const POLICY_TYPE_MAP: Record<string, string> = {
  'user-agreement': 'user_agreement',
  privacy: 'privacy_agreement',
}

/** 路由 type → 后端 type. 未命中映射则原样返回 (允许后端直接用同名 type) */
export function resolveBackendPolicyType(routeType: string | undefined): string | undefined {
  if (!routeType) return undefined
  return POLICY_TYPE_MAP[routeType] ?? routeType
}
